import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function dateFinValiditeValidator(dateType: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const dateDebutvalidite = moment(control.parent?.get('dateDebutValidite')?.value);
    const dateFinValidite =
      dateType === 'immo'
        ? moment(control.parent?.get('dateFinValiditeImmo')?.value)
        : moment(control.parent?.get('dateFinValidite')?.value);

    if (!dateFinValidite || !dateDebutvalidite) {
      return null;
    }

    const result = dateFinValidite <= dateDebutvalidite ? { finBeforeDebut: true } : null;

    if (dateType === 'fin' || dateType === 'immo') {
      control.parent?.get('dateDebutValidite')?.setErrors(result);
    } else {
      control.parent?.get('dateFinValidite')?.setErrors(result);
      control.parent?.get('dateFinValiditeImmo')?.setErrors(result);
    }

    return result;
  };
}
